import Page from '@/components/common/page';
import { Entities } from '../common/entities';
import { initializeSearchInputs } from '../common/search/search-input';

export class NewNewsPageIndex extends Page {
    init() {
        new Entities('.info-index__entity', (post) => {
            window.location.href = post.dataset.link;
        });

        initializeSearchInputs(
            document.querySelectorAll('.search-input'),
            document.querySelectorAll('.search-input__button'),
            'news'
        );
    }
}
